module.exports = __webpack_public_path__ + "static/img/s2model6.4b67e7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/model/s2model6.png
// module id = PrnJ
// module chunks = 0